<template>
    <div class="pp-content">
        <div class="pp-header pp-header--simple pp-header--image-generic">
            <div class="pp-header__title">
                Pristine Streaming
            </div>
            <div class="pp-header__content">
                Makes discovering and listening to music enjoyable and exciting
            </div>
        </div>
        <div class="pp-content__page">
            <div class="pp-tabs">
                <ul class="pp-tabs__headers">
                    <li class="pp-tabs__headers__header pp-tabs__headers__header--active">
                        <router-link to="/browse">
                            Popular
                        </router-link>
                    </li>
                    <li class="pp-tabs__headers__header">
                        <router-link to="/browse/albums">
                            Albums
                        </router-link>
                    </li>
                    <li v-if="$root.view != 'mobile'" class="pp-tabs__headers__header">
                        <router-link to="/browse/tracks">
                            Tracks
                        </router-link>
                    </li>
                    <li v-if="$root.view == 'mobile'" class="pp-tabs__headers__header">
                        <router-link to="/browse/new">
                            New
                        </router-link>
                    </li>
                    <li class="pp-tabs__headers__header">
                        <router-link to="/browse/composers">
                            Composers
                        </router-link>
                    </li>
                    <li class="pp-tabs__headers__header">
                        <router-link to="/browse/ensembles">
                            Ensembles
                        </router-link>
                    </li>
                    <li class="pp-tabs__headers__header">
                        <router-link to="/browse/artists">
                            Artists
                        </router-link>
                    </li>
                    <li class="pp-tabs__headers__header">
                        <router-link to="/browse/exclusive">
                            Exclusives
                        </router-link>
                    </li>
                    <li v-if="$root.view == 'mobile'" class="pp-tabs__headers__header">
                        <router-link to="/browse/tracks">
                            Tracks
                        </router-link>
                    </li>
                </ul>
                <div class="pp-tabs__content">
                    <div class="pp-section">
                        <div class="pp-section__header">
                            Popular Albums
                        </div>
                        <loading-indicator v-if="loadingAlbums"></loading-indicator>
                        <album-grid :mobile-horizontal="true" v-if="albums.length > 0" :items="albums" :max-rows="1"></album-grid>
                        <div v-if="albums.length > 0" class="pp-section__readmore">
                            <router-link to="/browse/albums">
                                See all albums
                            </router-link>
                        </div>
                    </div>
                    <div class="pp-section">
                        <div class="pp-section__header">
                            Popular Tracks
                        </div>
                        <loading-indicator v-if="loadingTracks"></loading-indicator>
                        <track-list v-if="tracks.length > 0" :items="tracks" :max-rows="5"></track-list>
                        <div v-if="tracks.length > 0" class="pp-section__readmore">
                            <router-link to="/browse/tracks">
                                See all tracks
                            </router-link>
                        </div>
                    </div>
                    <div class="pp-section">
                        <div class="pp-section__header">
                            Popular Composers
                        </div>
                        <artist-grid v-if="composers.length > 0"
                                     link-to="/browse/composers/{id}"
                                     :items="composers"
                                     :mobile-horizontal="true"
                                     :max-rows="1">
                        </artist-grid>
                        <loading-indicator v-if="loadingComposers"></loading-indicator>
                        <div v-if="composers.length > 0" class="pp-section__readmore">
                            <router-link to="/browse/composers">
                                See all composers
                            </router-link>
                        </div>
                    </div>
                    <div class="pp-section">
                        <div class="pp-section__header">
                            Popular Ensembles
                        </div>
                        <artist-grid v-if="ensembles.length > 0"
                                     link-to="/browse/ensembles/{id}"
                                     :items="ensembles"
                                     :mobile-horizontal="true"
                                     :max-rows="1">
                        </artist-grid>
                        <loading-indicator v-if="loadingEnsembles"></loading-indicator>
                        <div v-if="ensembles.length > 0" class="pp-section__readmore">
                            <router-link to="/browse/ensembles">
                                See all ensembles
                            </router-link>
                        </div>
                    </div>
                    <div class="pp-section">
                        <div class="pp-section__header">
                            Popular Artists
                        </div>
                        <artist-grid v-if="artists.length > 0"
                                     link-to="/browse/artists/{id}"
                                     :items="artists"
                                     :mobile-horizontal="true"
                                     :max-rows="1"
                                     :use-lastname-placeholder="true">
                        </artist-grid>
                        <loading-indicator v-if="loadingArtists"></loading-indicator>
                        <div v-if="artists.length > 0" class="pp-section__readmore">
                            <router-link to="/browse/artists">
                                See all artists
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import TrackList from '../components/TrackList.vue';
import AlbumGrid from '../components/AlbumGrid.vue';
import ArtistGrid from '../components/ArtistGrid.vue';
import LoadingIndicator from '../components/LoadingIndicator.vue';
import { api } from '../API.js';

export default {
    name: 'home',
    components: {
        AlbumGrid,
        ArtistGrid,
        LoadingIndicator,
        TrackList,
    },
    watch: {
        '$route': 'fetchData'
    },
    methods: {
        fetchData() {
            this.loading = true;

            console.log('fetchData');

            api.get('/albums', [], {
                limit: 10,
                page: 1
            }, (data) => {
                this.albums = data.albums;
                this.loadingAlbums = false;
            }, () => {
                console.log('Error!');
            });

            api.get('/tracks', [], {
                limit: 5,
                page: 1
            }, (data) => {
                this.tracks = data.tracks;
                this.loadingTracks = false;
            });

            api.get('/composers', [], {
                limit: 10,
                page: 1
            }, (data) => {
                this.composers = data.composers;
                this.loadingComposers = false;
            });

            api.get('/ensembles', [], {
                limit: 10,
                page: 1
            }, (data) => {
                this.ensembles = data.ensembles;
                this.loadingEnsembles = false;
            });

            api.get('/artists', [], {
                limit: 10,
                page: 1
            }, (data) => {
                this.artists = data.artists;
                this.loadingArtists = false;
            });
        },
    },
    mounted() {
            this.fetchData();
    },
    data() {
        return {
            loadingTracks: true,
            loadingAlbums: true,
            loadingComposers: true,
            loadingEnsembles: true,
            loadingArtists: true,
            loading: true,
            albums: [],
            tracks: [],
            composers: [],
            ensembles: [],
            artists: [],
        };
    },

}
</script>



// WEBPACK FOOTER //
// Home.vue?1f3a5286